import { Components, Theme } from "@mui/material";

const MuiTooltip: Components<Theme>["MuiTooltip"] = {
  defaultProps: {
    enterTouchDelay: 0,
    leaveTouchDelay: 4000,
  },
  styleOverrides: {
    tooltip: {
      backgroundColor: "#636c70",
    },
  },
};

export default MuiTooltip;
